import { Component, OnInit, inject,  model } from '@angular/core';
import { MatChipsModule } from '@angular/material/chips';
import { MatOptionModule } from '@angular/material/core';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatIconModule } from '@angular/material/icon';
import { MatSelectModule } from '@angular/material/select';
import { BookService } from 'src/app/services/book.service';
import { MessageService } from 'src/app/services/message.service';
@Component({
    selector: 'kbm-has-read-chips',
    templateUrl: './has-read-chips.component.html',
    styleUrls: ['./has-read-chips.component.scss'],
    standalone: true,
    imports: [
        MatChipsModule,
        MatSelectModule,
        MatFormFieldModule,
        MatIconModule,
        MatOptionModule,
        
    ]
})
export class HasReadChipsComponent implements OnInit {

  hasRead = model.required<string[]>();

  allUsers: string[] = [];
  
  visible = true;
  selectable = true;
  removable = true;
  addOnBlur = false;

  bookService = inject(BookService);
  messageService = inject(MessageService);

  ngOnInit(): void {
    this.loadUserList();
  }

  async loadUserList() {
    try {
      const users = await this.bookService.getUsers();
      this.allUsers = users.map(u => u.username);
    }
    catch (err) {
      this.messageService.showMessage(JSON.stringify(err), "error");
    }
  }

  onHasReadChange(evt: any) {
    this.hasRead.set(evt);
  }

}